import React, { useState } from "react";
import { Form, Input, Button, Typography, message, Card } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import AxiosService from "../services/APIService";

const { Title } = Typography;

const ResetPassword = () => {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const { token } = useParams(); // Assuming you pass token via URL

    const apiService = new AxiosService();

    const onFinish = (values) => {
        const { password, confirmPassword } = values;

        if (password !== confirmPassword) {
            return message.error("Passwords do not match!");
        }

        apiService
            .post("/auth/reset-password", { token, password, confirmPassword })
            .then(() => {
                message.success("Password reset successful. Please login.");
                navigate("/login");
            })
            .catch((err) => {
                message.error(err?.error || "Reset failed");
            });
    };

    return (
        <div className="reset-password-container">
            <Card className="reset-password-card">
                <Title level={3}>Reset Your Password</Title>
                <Form form={form} layout="vertical" onFinish={onFinish}>
                    <Form.Item
                        name="password"
                        label="New Password"
                        rules={[{ required: true, message: "Please enter a new password" }]}
                    >
                        <Input.Password />
                    </Form.Item>
                    <Form.Item
                        name="confirmPassword"
                        label="Confirm Password"
                        rules={[{ required: true, message: "Please confirm your password" }]}
                    >
                        <Input.Password />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit">Save</Button>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
};

export default ResetPassword;
